import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ROUTES } from 'src/app/constants';
import { SignupComponent } from './signup.component';

const routes: Routes = [
	{ path: ROUTES.ROOT, component: SignupComponent }
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})

export class SignupRoutingModule { }
